import i18n from 'invision-core/src/components/i18n/i18n';
import LocaleKeys from '../../locales/keys';
import { RIGHT_ALIGNED_HEADER_TEMPLATE } from 'invision-ui/lib/components/collections/datatable/cellTemplates/cellTemplates';
import { DateTimeHelper } from 'invision-core';
export var ADJUSTMENTS = 2;
export var INVOICES = 1;
export var CREDIT_NOTES = 16;
export var DEBIT_NOTES = 32;
export var PAYMENTS = 4;
export var MISC = 2;
export var ITEM = 1;
export var OPEN_INVOICES = 64;
export var OVERALL = 0;
export var DEPOSITS = 8;
export var FUTURE_INVOICE_URL = 'index.customercare.customer.billingpayments.futureinvoice';
export var FUTURE_INVOICE_DETAILS_URL = 'index.customercare.customer.billingpayments.futureinvoicedetails';
export var BILLING_INVOICE_LIST_URL = 'index.customercare.customer.billingpayments.list';
export var BILLING_INVOICE_DETAILS_URL = 'index.customercare.customer.billingpayments.detail';
export var FUTURE_INVOICE_CALCULATION_COMPLETION_STATUS = {
  IN_PROGRESS: 1,
  READY: 2
};
export var FUTURE_INVOICE_START_CALCULATION_ACTIONS = {
  START_CALCULATION: 1,
  CHECK_STATUS_OR_START: 2
};
export default {
  ADJUSTMENTS: ADJUSTMENTS,
  INVOICES: INVOICES,
  PAYMENTS: PAYMENTS,
  OVERALL: OVERALL,
  MISC: MISC,
  ITEM: ITEM
};
export var ACCOUNT_SUMMARY_ITEM_LEVEL_MENU_OPTIONS = {
  APPLY_CREDIT_NOTE: 1,
  VIEW_TRANSACTION_DETAILS: 2,
  VIEW_RECEIVABLES: 3
};
export var FUTURE_INVOICE_COLUMNDEFS = [{
  name: 'Date Generated',
  displayName: i18n.translate(LocaleKeys.DATE_GENERATED),
  cellTemplate: require('./futureInvoices/cellTemplates/future.invoices.date.html'),
  enableSorting: false,
  resizable: false,
  width: '250'
}, {
  name: 'Invoice Dates',
  displayName: i18n.translate(LocaleKeys.INVOICE_DATES),
  cellTemplate: require('./futureInvoices/cellTemplates/future.invoices.duration.html'),
  enableSorting: false,
  resizable: false
}, {
  name: 'Estimated Invoice Amount',
  displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.ESTIMATED_INVOICE_AMOUNT),
  cellTemplate: require('./futureInvoices/cellTemplates/future.invoices.estimated.amount.html'),
  enableSorting: false,
  resizable: false,
  width: '228'
}, {
  name: 'View Details',
  displayName: '',
  cellTemplate: require('./futureInvoices/cellTemplates/future.invoices.open.new.window.html'),
  enableSorting: false,
  resizable: false,
  width: '150'
}];
export var FUTURE_INVOICE_REFRESH_TIMEOUT = 5;
export var MISC_ADJUSTMENT_ID = 0;
export var CREATE_NOTE_ID = 1;
export var APPLY_TAX_CERTIFICATE_ID = 2;
export var ENABLE_CREATE_NOTE = 'enable_credit_debit_note';
export var ADJUSTMENT_CONFIG_ENABLED = 'True';
export var ENABLE_GENERATE_STATEMENT = 'generate_statement';
export var CREDIT_NOTE_TYPE = 'Credit';
export var billingLedgerTabList = function billingLedgerTabList() {
  return {
    OPEN_INVOICES: {
      active: false,
      name: i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.OPEN_INVOICES),
      key: 'OPEN_INVOICES'
    },
    ACCOUNT_SUMMARY: {
      active: false,
      name: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.ACCOUNT_SUMMARY),
      key: 'ACCOUNT_SUMMARY'
    },
    DEPOSITS: {
      active: false,
      name: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.DEPOSITS),
      key: 'DEPOSITS'
    }
  };
};
export var OPEN_INVOICES_COL_DEFS = [{
  field: 'invoice',
  displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.INVOICE),
  cellTemplate: require('./list/tabs/cellTemplates/openInvoice.invoice.template.html'),
  width: '*'
}, {
  field: 'invoiceType',
  displayName: i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.INVOICE_TYPE),
  width: '*'
}, {
  field: 'dateCreated',
  displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.DATE_CREATED),
  width: '*',
  enableSorting: true,
  sortingAlgorithm: DateTimeHelper.dateTimeComparator
}, {
  field: 'charge',
  displayName: i18n.translate(LocaleKeys.CHARGE),
  cellTemplate: require('./list/tabs/cellTemplates/openInvoice.charge.template.html'),
  width: 200,
  minWidth: 70,
  cellClass: 'c-dataType-number'
}, {
  field: 'dueDate',
  displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.DUE_DATE),
  minWidth: 70,
  enableSorting: true,
  sortingAlgorithm: DateTimeHelper.dateTimeComparator
}, {
  field: 'payments',
  displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.PAYMENTS),
  cellTemplate: require('./list/tabs/cellTemplates/openInvoice.payment.template.html'),
  headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
  cellClass: 'c-dataType-number',
  minWidth: 70
}, {
  field: 'adjustments',
  displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.ADJUSTMENTS),
  cellTemplate: require('./list/tabs/cellTemplates/openInvoice.adjustments.template.html'),
  headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
  cellClass: 'c-dataType-number',
  minWidth: 70
}, {
  field: 'invoiceBalance',
  displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.INVOICE_BALANCE),
  cellTemplate: require('./list/tabs/cellTemplates/openInvoice.invoice.balance.template.html'),
  headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
  cellClass: 'c-dataType-number',
  minWidth: 70
}];
export var BILLING_PAYMENTS_SEARCH_PLACEHOLDER = function BILLING_PAYMENTS_SEARCH_PLACEHOLDER() {
  return "".concat(i18n.translate(LocaleKeys.FILTER_SEARCH_PLACEHOLDER), " ").concat(i18n.translate(LocaleKeys.INVOICE_NUMBER));
};
export var BILL_ADJUSTMENT = 1001;
export var MISC_ADJUSTMENT = 1002;
export var CONVERSION_CREDIT_ADJUSTMENT = 1004;
export var CONVERSION_DEBIT_ADJUSTMENT = 1005;
export var CREDIT_NOTE_ADJUSTMENT = 1006;
export var CONVERT_TO_CREDIT = 1006;
export var DEBIT_NOTE_ADJUSTMENT = 1007;
export var VIEW_RECEIVABLES = 'VIEW_RECEIVABLES';